module.exports = __webpack_public_path__ + "img/addon_new.60e98363.svg";